import { render, staticRenderFns } from "./NoteItem.vue?vue&type=template&id=17faf380&"
import script from "./NoteItem.vue?vue&type=script&lang=js&"
export * from "./NoteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NoteItem.vue"
export default component.exports